import { ApplicationRoutes } from '../constants/appRoutes';
import { RouteAuthenticationRequirement, RouteItem } from '@cks-internal/react-base';
import { AppRoles } from '../constants/appRoles';
import { Layout } from '../components/layout/layout';

export const CleaningRoutes: RouteItem = {
  text: 'Cleaning',
  authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
  allowedRoles: [AppRoles.CleaningAdmin, AppRoles.Admin, AppRoles.TeamMember, AppRoles.Manager],
  layout: <Layout />,
  subItems: [
    {
      text: 'Start Cleaning',
      allowedRoles: [AppRoles.TeamMember],
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      path: ApplicationRoutes.cleaning.startCleaning,
      async lazy() {
        const component = await import('../features/cleaning/dashboard/StartCleaning');
        return { Component: component.StartCleaning };
      }
    },
    {
      allowedRoles: [AppRoles.TeamMember, AppRoles.Manager],
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      path: `/cleaning/cleaning-checklist/:type/:id`,
      async lazy() {
        const component = await import('../features/cleaning/checklist/CleaningChecklist');
        return { Component: component.CleaningChecklist };
      }
    },
    {
      text: 'Training Videos',
      allowedRoles: [AppRoles.TeamMember],
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      path: ApplicationRoutes.training.list,
      async lazy() {
        const component = await import('../features/training/view/TrainingVideos');
        return { Component: component.TrainingVideos };
      }
    },
    {
      text: 'Inventory Report',
      allowedRoles: [AppRoles.Helper, AppRoles.TeamMember, AppRoles.Admin, AppRoles.UserAdmin],
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      path: ApplicationRoutes.cleaning.inventoryReport,
      async lazy() {
        const component = await import('../features/cleaning/inventoryReport/InventoryReport');
        return { Component: component.InventoryReport };
      }
    },
    {
      allowedRoles: [AppRoles.TeamMember],
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      path: ApplicationRoutes.training.view,
      async lazy() {
        const component = await import('../features/training/view/TrainingVideoPlayer');
        return { Component: component.TrainingVideoPlayer };
      }
    }
  ]
};
